module.exports = __webpack_public_path__ + "img/rune-holo.b172aac4.svg";